angular.module('tf.controllers')

    .controller('AccountFarmController', ['$scope','FarmService', 'Session','ConfirmExitService','HttpService', '$timeout',
        function ($scope, FarmService, Session, ConfirmExitService, HttpService, $timeout){

            $scope.farm = angular.copy(Session.farm);

            $scope.fields = ['Digital Media', 'Post Production', 'VFX', 'Broadcasting / Live Television', 'Gaming', 'Advertising & Marketing', 'Integration & Installation', 'Other'];
            $scope.timezones = moment.tz.names();
            $scope.plan = {};
            $scope.isFarmAccountLoaded = false;

            if($scope.farm.company && $scope.farm.company.field && $scope.fields.indexOf($scope.farm.company.field) < 0){
                $scope.farm.company.otherField = $scope.farm.company.field;
                $scope.farm.company.field = 'Other';
            }

            var unwatch;

            $scope.$on('$viewContentLoaded', function(){
                $timeout(function(){
                    $scope.isFarmAccountLoaded = true;
                }, 1);
            });

            $scope.isOwner = function(){
                return Session.isFarmOwner();
            };
            $scope.isPayAsYouGoPlan = function(){
                return Session.user.isPayAsYouGoPlan();
            };

            $scope.updateFarm = function(){
                $scope.isWorking = true;
                if($scope.farm.company && $scope.farm.company.field && $scope.farm.company.field !== 'Other'){
                    delete $scope.farm.company.otherField;
                }
                HttpService.post('farm/' + Session.farm._id, {farm : $scope.farm}).then(function(res){
                    Session.updateFarm(res.data);
                    window.onbeforeunload = null;
                    $scope.settingsChanged = false;
                    $scope.isWorking = false;
                    monitorChanges();
                });
            };


            var monitorChanges = function(){
                unwatch =  $scope.$watch('farm', function(newVal, oldVal){
                    if(newVal && oldVal && !_.isEqual(newVal, oldVal)){
                        unwatch();
                        $scope.settingsChanged = true;
                        if(!window.onbeforeunload) {
                            window.onbeforeunload = ConfirmExitService.onBeforeUnload("Are you sure you want to leave this page?");
                        }
                    }
                }, true);
            };

            monitorChanges();

            $scope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams) {
                if(window.onbeforeunload && $scope.settingsChanged) {
                    event.preventDefault();
                    ConfirmExitService.popup(toState, toParams, 'You have unsaved changes', 'Are you sure you want to leave?');
                }
            });

            FarmService.plan().then(function(plan){
                $scope.plan = plan;
            });

            $scope.subtractAndKeepPositive = function (num1, num2) {
                return Math.max(num1 - num2, 0);
            };

            $scope.addHeaderLink = () =>{
                $scope.farm.settings.header_links.push({
                    title: "New Link",
                    url : ''
                });
            };

            $scope.removeHeaderLink = (link) => {
                $scope.farm.settings.header_links.splice($scope.farm.settings.header_links.indexOf(link), 1);
            };

            //function initFarm(){
            //    FarmService.getFarm().then(function(farm){
            //        $scope.farm = farm;
            //    });
            //}


            //initFarm();

        }]);